<template>
  <q-page padding>
    <PageHeader>
      <template #title>Detalhe Picking: #{{ numero }}</template>
    </PageHeader>

    <div class="row col-12 q-gutter-sm q-mt-md text-brand-5">
      <span class="col-lg col-md col-xs-6 text-weight-bold">
        <div class="texto-titulo-input">Observação</div>
        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          v-model="comentario"
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
      <span class="col-lg col-md col-xs-5 text-weight-bold">
        <div class="texto-titulo-input">Status</div>
        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          v-model="status"
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
      <div class="col-lg col-md col-xs-6 text-weight-bold">
        <div class="texto-titulo-input">Unidade Origem</div>
        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          v-model="unidadeNomeOrigem"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-lg col-md col-xs-5 text-weight-bold">
        <div class="texto-titulo-input">Unidade Destino</div>
        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          v-model="unidadeNomeDestino"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
    </div>

    <div class="row col-12 q-gutter-sm q-mt-sm text-brand-5">
      <span class="col-lg col-md col-xs-6 text-weight-bold"
        ><div class="texto-titulo-input">Data Criação</div>
        <q-input
          v-if="dataCriacao"
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          v-model="dataCriacao"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />

        <q-input
          v-else
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
      <span class="col-lg col-md col-xs-5 text-weight-bold"
        ><div class="texto-titulo-input">Data Envio</div>

        <q-input
          v-if="dataEnvio != 'undefined undefined'"
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          v-model="dataEnvio"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />

        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
      <span class="col-lg col-md col-xs-6 text-weight-bold"
        ><div class="texto-titulo-input">Data Recebimento</div>
        <q-input
          v-if="dataRecebimento != 'undefined undefined'"
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          v-model="dataRecebimento"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />

        <q-input
          v-else
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
      <span class="col-lg col-md col-xs-5 text-weight-bold"
        ><div class="texto-titulo-input">Data Cancelamento</div>
        <q-input
          dense
          outlined
          v-if="dataCancelamento != 'undefined undefined'"
          bg-color="brand-7"
          disable
          v-model="dataCancelamento"
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />

        <q-input
          dense
          outlined
          bg-color="brand-7"
          disable
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </span>
    </div>

    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-sm q-gutter-sm"
    >
      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Numero Requisição</div>
        <q-input
          dense
          outlined
          disable
          label="Digite o Numero da requisição"
          v-model="filtros.requisicao"
          class="texto-titulo-input"
          maxlength="10"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Numero Reserva</div>
        <q-input
          dense
          outlined
          disable
          label="Digite o Numero da reserva"
          class="texto-titulo-input"
          v-model="filtros.reserva"
          maxlength="4"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>

      <div class="col-md col-xs-6">
        <div class="texto-titulo-input">Deposito</div>
        <q-input
          dense
          disable
          outlined
          label="Digite o Deposito"
          v-model="filtros.deposito"
          class="texto-titulo-input"
          maxlength="10"
        />
      </div>
      <div class="col-md col-xs-5">
        <div class="texto-titulo-input">Centro</div>
        <q-input
          dense
          outlined
          disable
          label="Digite o Centro"
          class="texto-titulo-input"
          v-model="filtros.centro"
          maxlength="10"
        />
      </div>
    </div>
    <div class="row col-12 q-mt-sm text-brand-5 text-weight-bold q-mr-md">
      <div class="col-md-3 col-xs-6">
        <div class="texto-titulo-input">Lote</div>
        <q-input
          dense
          disable
          outlined
          label="Digite o Lote"
          class="texto-titulo-input"
          v-model="filtros.lote"
          maxlength="10"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :columns="columns"
        :loading="disable"
        dense
        :grid="mobile"
        color="primary"
        :class="{ 'tabela-tamanho-fixo': !mobile }"
        row-key="id"
        flat
        v-model:pagination="pagination"
        no-data-label="Sem dados"
        @request="handleRequest"
        :rows-per-page-label="'Linhas Por Página'"
        :rows-per-page-options="[10, 25, 50, 100]"
      >
        <template v-slot:top>
          <div style="width: 100%" class="flex justify-between items-center">
            <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
              Pickings Selecionados para Transferência
            </div>
            <div class="flex q-gutter-x-sm">
              <q-btn
                color="primary"
                icon="print"
                label="Imprimir Listagem"
                no-caps
                @click="imprimirPicking"
              />
              <q-btn
                color="secondary"
                icon="print"
                label="Imprimir Listagem Agrupada"
                no-caps
                @click="imprimirPickingAgrupado"
              />
            </div>
          </div>
        </template>
        <template v-slot:item="props">
          <div class="q-pa-xs col-xs-12 col-sm-12 col-md-12">
            <div class="row card">
              <div class="col-12">
                <q-card-section class="row text-brand-5 text-grid-table">
                  <div class="col-12">
                    <span
                      ><strong>Nº Requisição:</strong>
                      {{ props.row?.voucherId }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Código:</strong>
                      {{ props.row?.detalhesProduto?.codigo }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Descrição:</strong>
                      {{ props.row?.detalhesProduto?.nome }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Localização:</strong>
                      {{ props.row?.detalhesProduto?.localizacao }}</span
                    >
                  </div>
                  <div class="col-12">
                    <span
                      ><strong>Estoque Origem:</strong>
                      {{ props.row?.detalhesProduto?.saldoEstoqueOrigem }}</span
                    >
                  </div>
                  <div class="col-12">
                    <div class="row col-12 items-center">
                      <strong class="q-mr-sm">Quantidade Atendida:</strong>
                      <div class="row col-12">
                        <q-input
                          dense
                          outlined
                          label="Digite a Quantidade"
                          class="col-md-3 col-xs-4"
                          v-model="props.row.quantidadeAtendida"
                          maxlength="10"
                        />
                        <q-select
                          class="col-md-5 col-xs-6 q-ml-sm"
                          dense
                          v-if="props.row.detalhesProduto.origemControlaLote"
                          :disable="
                            !props.row.detalhesProduto.origemControlaLote
                          "
                          outlined
                          style="min-width: 120px"
                          option-label="lote"
                          behavior="menu"
                          v-model="props.row.loteSelecionado"
                          :options="props.row.detalhesProduto.origemLotes"
                          label="lote"
                        />
                        <q-btn
                          icon="add"
                          flat
                          dense
                          color="positive"
                          v-if="
                            props.row.detalhesProduto.origemControlaLote &&
                            props.row.detalhesProduto?.origemLotes.length > 1
                          "
                          :disable="
                            !props.row.detalhesProduto.origemControlaLote
                          "
                          @click="
                            props.row.lotesAdicionais.push({
                              loteNome: '',
                              quantidade: '',
                            })
                          "
                        />
                      </div>
                      <section
                        style="flex-wrap: nowrap"
                        class="row col-12 q-mt-sm"
                        v-for="(lote, index) in props.row.lotesAdicionais"
                        :key="index"
                      >
                        <q-input
                          dense
                          outlined
                          label="Digite a Quantidade"
                          class="col-md-3 col-xs-4"
                          v-model="lote.quantidade"
                          maxlength="10"
                        />
                        <q-select
                          class="col-md-5 col-xs-6 q-ml-sm"
                          dense
                          behavior="menu"
                          :disable="
                            !props.row.detalhesProduto.origemControlaLote
                          "
                          outlined
                          option-label="lote"
                          v-model="lote.loteNome"
                          :options="props.row.detalhesProduto.origemLotes"
                          label="lote"
                        />
                        <q-btn
                          icon="delete"
                          flat
                          dense
                          color="red"
                          @click="props.row.lotesAdicionais.splice(index, 1)"
                        />
                      </section>
                    </div>
                  </div>
                </q-card-section>
              </div>
            </div>
          </div>
        </template>
        <template #body-cell-descricao="props">
          <q-td :props="props">
            <div class="column">
              {{ props.row?.detalhesProduto?.nome }}
            </div>
          </q-td>
        </template>

        <template #body-cell-quantidade="props">
          <q-td :props="props">
            <div class="column">
              {{ props.row?.detalhesProduto?.quantidade }}
            </div>
          </q-td>
        </template>
        <template #body-cell-localizacao="props">
          <q-td :props="props">
            <div>
              {{ props.row?.detalhesProduto?.localizacao }}
            </div>
          </q-td>
        </template>

        <template #body-cell-codigo="props">
          <q-td :props="props">
            <div class="column">
              {{ props.row?.detalhesProduto?.codigo }}
            </div>
          </q-td>
        </template>

        <template #body-cell-deposito="props">
          <q-td :props="props">
            <div class="column">
              {{ props.row?.detalhesProduto?.deposito }}
            </div>
          </q-td>
        </template>

        <template #body-cell-lote="props">
          <q-td :props="props">
            <div class="row">
              <section style="flex-wrap: nowrap" class="row">
                <q-input
                  :class="
                    props.row.quantidadeAtendida > props.row.quantidadeOriginal
                      ? 'quantidade-input-picking'
                      : ''
                  "
                  dense
                  outlined
                  label="Digite a Quantidade"
                  style="min-width: 200px; max-width: 200px"
                  v-model="props.row.quantidadeAtendida"
                  maxlength="10"
                >
                  <q-tooltip
                    no-parent-event
                    :model-value="
                      props.row.quantidadeAtendida >
                      props.row.quantidadeOriginal
                    "
                    class="bg-negative"
                    anchor="top middle"
                    self="bottom middle"
                    :offset="[10, 10]"
                  >
                    Quantidade digitada muito acima
                  </q-tooltip>
                </q-input>
                <q-select
                  class="col-2 q-ml-sm"
                  dense
                  v-if="props.row.detalhesProduto.origemControlaLote"
                  :disable="!props.row.detalhesProduto.origemControlaLote"
                  outlined
                  style="min-width: 120px"
                  option-label="lote"
                  v-model="props.row.loteSelecionado"
                  :options="props.row.detalhesProduto.origemLotes"
                  label="lote"
                />
                <q-btn
                  icon="add"
                  flat
                  dense
                  color="positive"
                  v-if="
                    props.row.detalhesProduto.origemControlaLote &&
                    props.row.detalhesProduto?.origemLotes.length > 1
                  "
                  :disable="!props.row.detalhesProduto.origemControlaLote"
                  @click="
                    props.row.lotesAdicionais.push({
                      loteNome: '',
                      quantidade: '',
                    })
                  "
                />
              </section>
              <section
                style="flex-wrap: nowrap"
                class="row q-mt-sm"
                v-for="(lote, index) in props.row.lotesAdicionais"
                :key="index"
              >
                <q-input
                  dense
                  outlined
                  label="Digite a Quantidade"
                  style="min-width: 200px"
                  v-model="lote.quantidade"
                  maxlength="10"
                />
                <q-select
                  class="col-2 q-ml-sm"
                  dense
                  :disable="!props.row.detalhesProduto.origemControlaLote"
                  outlined
                  style="min-width: 120px"
                  option-label="lote"
                  v-model="lote.loteNome"
                  :options="props.row.detalhesProduto.origemLotes"
                  label="lote"
                />
                <q-btn
                  icon="delete"
                  flat
                  dense
                  color="red"
                  @click="props.row.lotesAdicionais.splice(index, 1)"
                />
              </section>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>

    <q-dialog v-model="form" position="right">
      <q-card style="max-width: 426px; min-width: 426px" class="q-pa-md modal">
        <div class="row">
          <q-icon
            style="cursor: pointer"
            name="close"
            class="q-mr-md icon-modal"
            @click="form = false"
          />
          <span class="texto-titulo-modal">
            <span>
              <span> Finalizar Picking </span>
            </span>
          </span>
        </div>

        <div class="col-md-3 col-xs-6 q-mt-sm">
          <div class="texto-titulo-input text-weight-bold">Transportador</div>
          <SelecaoSolicitante @emitirFuncionario="receberTransportador" />
        </div>
        <div class="col-md-3 col-xs-6 q-mt-sm">
          <div class="texto-titulo-input text-weight-bold">
            {{ labelSolicitante }}
          </div>
          <SelecaoSolicitante @emitirFuncionario="receberSolicitante" />
        </div>
        <div class="col-md-3 col-xs-6 q-mt-sm">
          <div class="texto-titulo-input text-weight-bold">Separador</div>
          <SelecaoSolicitante @emitirFuncionario="receberSeparador" />
        </div>

        <div class="col-md-3 col-xs-6 q-mt-sm">
          <div class="texto-titulo-input text-weight-bold">Descriçao</div>

          <q-input
            v-model="descricao"
            dense
            outlined
            autogrow
            type="textarea"
            label="Descriçao"
          />
        </div>

        <div class="col-md-3 col-xs-6 q-mt-sm">
          <div class="texto-titulo-input text-weight-bold">Obervacao</div>

          <q-input
            v-model="observacao"
            dense
            outlined
            autogrow
            type="textarea"
            label="Descriçao"
          />
        </div>

        <q-btn
          label="Finalizar picking"
          icon="add"
          color="positive"
          class="q-mt-md"
          no-caps
          @click="confirmacao = true"
        />
      </q-card>

      <dialog-confirm
        mensagem="Tem certeza que deseja continuar? A finalização do picking impede a edição dos produtos"
        :exibir="confirmacao"
        @resultado="enviar"
      >
      </dialog-confirm>
    </q-dialog>

    <div class="row col-12 q-mt-xl">
      <div
        v-if="
          $store.state.autenticacao.cliente[0] == 'staging-cerradinho' ||
          $store.state.autenticacao.cliente[0] == 'cerradinho'
        "
      >
        <q-btn
          label="Finalizar picking"
          icon="add"
          :disable="
            rows?.filter((value) => {
              return value.quantidadeAtendida > value.quantidadeOriginal;
            }).length != 0
          "
          color="positive"
          no-caps
          @click="form = true"
        />
      </div>

      <div v-else>
        <q-btn
          label="Finalizar picking"
          icon="add"
          color="positive"
          no-caps
          class="btn-grid"
          @click="form = true"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { watchDebounced } from "@vueuse/core";
import DialogConfirm from "../components/DialogConfirm.vue";
import SelecaoSolicitante from "../components/SelecaoSolicitante.vue";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";
import PageHeader from "../../../components/PageHeader.vue";

export default {
  components: {
    DialogConfirm,
    SelecaoSolicitante,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const quasar = useQuasar();

    const columns = ref([
      {
        name: "voucherId",
        label: "Numero Requisição",
        field: "voucherId",
        align: "left",
        sortable: false,
      },

      {
        name: "reserva",
        label: "Numero Reserva",
        field: (row) => row?.detalhesProduto?.reserva,
        align: "left",
        sortable: false,
      },
      {
        name: "solicitante",
        label:
          store.state.autenticacao.cliente[0] == "cerradinho" ||
          store.state.autenticacao.cliente[0] == "staging-cerradinho"
            ? "Colaborador"
            : "Solicitante",
        field: (row) =>
          row?.detalhesProduto?.solicitanteVoucher?.nome +
          " - " +
          `(${row?.detalhesProduto?.solicitanteVoucher?.matricula})`,
        align: "left",
        sortable: false,
      },
      {
        name: "centroCusto",
        label: "Centro de custo",
        field: (row) =>
          row?.detalhesProduto?.centroCusto?.codigo +
          " - " +
          row?.detalhesProduto?.centroCusto?.descricao,
        align: "left",
        style: "width: 20px",
        sortable: false,
      },
      {
        name: "centro",
        label: "Centro",
        field: (row) => row?.detalhesProduto?.centro,
        align: "left",
        style: "width: 20px",
        sortable: false,
      },

      {
        name: "deposito",
        label: "Deposito",
        field: "deposito",
        align: "left",
        sortable: false,
      },
      {
        name: "codigo",
        label: "Codigo",
        field: "codigo",
        align: "left",
        sortable: false,
      },
      {
        name: "turno",
        label: "Turno",
        field: (row) => row?.detalhesProduto?.solicitanteVoucher?.turno,
        align: "left",
        sortable: false,
        style: "white-space: normal",
      },

      {
        name: "descricao",
        label: "Descrição",
        field: "descricao",
        align: "left",
        sortable: false,
      },
      {
        name: "localizacao",
        label: "Localizacao",
        field: "localizacao",
        align: "left",
        sortable: false,
      },
      {
        name: "preco",
        label: "Valor Unitario",
        field: (row) =>
          row?.detalhesProduto?.preco?.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          }),
        align: "left",
        sortable: false,
      },

      {
        name: "valor total",
        label: "Valor Total",
        field: (row) =>
          row?.valorTotal?.toLocaleString("pt-br", {
            style: "currency",
            currency: "BRL",
          }),
        align: "left",
        sortable: false,
      },
      {
        name: "saldo",
        label: "Estoque Origem",
        field: (row) => row?.detalhesProduto?.saldoEstoqueOrigem,
        align: "left",
        sortable: false,
      },
      {
        name: "quantidadeOriginal",
        label: "Quantidade Solicitada",
        field: "quantidadeOriginal",
        align: "left",
        sortable: false,
      },

      {
        name: "lote",
        label: "Quantidade Atendida / Lote",
        field: "lote",
        align: "left",
        sortable: false,
      },
    ]);

    const filtros = ref({
      unidade: null,
      requisicao: null,
      reserva: null,
      deposito: null,
      centro: null,
      lote: null,
      destino: null,
    });

    const comentario = ref("");
    const status = ref("");
    const form = ref(false);
    const loteBase = ref([]);
    const descricao = ref("");
    const observacao = ref("");
    const unidadeNomeDestino = ref("");
    const unidadeNomeOrigem = ref("");
    const dataCriacao = ref("");
    const dataEnvio = ref("");
    const dataRecebimento = ref("");
    const dataCancelamento = ref("");
    const confirmacao = ref(false);
    const idPicking = route.params && route.params.id ? route.params.id : "";
    const finalizacaoPessoas = ref({
      transportador: "",
      solicitante: "",
      separador: "",
    });
    const disable = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 50,
      rowsNumber: 50,
    });
    let mobile = ref(false);
    const rows = ref([]);
    const numero = ref(null);
    const labelSolicitante = ref(
      store.state.autenticacao.cliente[0] == "cerradinho" ||
        store.state.autenticacao.cliente[0] == "staging-cerradinho"
        ? "Lider"
        : "Solicitante"
    );
    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const getData = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      try {
        let response = await store.dispatch("pkg/getListagemPickings", {
          vendor_id: filtros.value?.unidade?.id,
          pickingUuid: idPicking ? idPicking : undefined,
        });

        if (
          store.state.autenticacao.cliente[0] == "cerradinho" ||
          store.state.autenticacao.cliente[0] == "staging-cerradinho"
        ) {
          columns.value = columns.value.filter((value) => {
            if (
              value.name != "centroCusto" &&
              value.name != "valor total" &&
              value.name != "deposito" &&
              value.name != "preco"
            ) {
              return value;
            }
          });
        }

        rows.value = response.data?.result?.dados?.[0]?.itens.map((value) => {
          return { ...value, lotesAdicionais: [] };
        });
        numero.value = response.data.result?.dados?.[0].numero;
        comentario.value = response.data.result?.dados?.[0].observacao;
        status.value = response.data.result?.dados?.[0].status;
        unidadeNomeDestino.value =
          response.data.result?.dados?.[0].unidadeNomeDestino;
        unidadeNomeOrigem.value =
          response.data.result?.dados?.[0].unidadeNomeOrigem;
        dataCriacao.value =
          response.data.result?.dados?.[0]?.dataCriacao
            ?.split(" ")[0]
            .split("-")
            .reverse()
            .join("/") +
          " " +
          response.data.result?.dados?.[0]?.dataCriacao?.split(" ")[1];
        dataEnvio.value =
          response.data.result?.dados?.[0]?.dataEnvio
            ?.split(" ")[0]
            .split("-")
            .reverse()
            .join("/") +
          " " +
          response.data.result?.dados?.[0]?.dataEnvio?.split(" ")[1];
        dataRecebimento.value =
          response.data.result?.dados?.[0]?.dataRecebimento
            ?.split(" ")[0]
            .split("-")
            .reverse()
            .join("/") +
          " " +
          response.data.result?.dados?.[0]?.dataRecebimento?.split(" ")[1];
        dataCancelamento.value =
          response.data.result?.dados?.[0]?.dataCancelamento
            ?.split(" ")[0]
            .split("-")
            .reverse()
            .join("/") +
          " " +
          response.data.result?.dados?.[0]?.dataCancelamento?.split(" ")[1];

        disable.value = false;
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const enviar = async (resultado) => {
      confirmacao.value = false;

      let produtos = rows.value.map((value) => {
        return {
          voucherId: +value.voucherId,
          produtos: [
            {
              productId: +value.productId,
              quantidadeAtendida: +value.quantidadeAtendida,
              lote:
                value.detalhesProduto && value.detalhesProduto.controlaLotre
                  ? value.loteSelecionado?.lote
                  : undefined,
            },
          ],
        };
      });

      if (resultado) {
        try {
          await store.dispatch("pkg/finalizarPicking", {
            solicitanteId:
              +finalizacaoPessoas.value.solicitante == 0
                ? undefined
                : +finalizacaoPessoas.value.solicitante,
            separadorId:
              +finalizacaoPessoas.value.separador == 0
                ? undefined
                : +finalizacaoPessoas.value.separador,
            transportadorId:
              +finalizacaoPessoas.value.transportador == 0
                ? undefined
                : +finalizacaoPessoas.value.transportador,
            id: idPicking,
            editarQuantidades: produtos,
            descricao: descricao.value,
            observacao: observacao.value,
          });

          disable.value = false;
          router.push({
            name: "pkg-detalhe-transferencia",
            params: { id: numero.value },
          });
          produtos = [];
        } catch (error) {
          quasar.notify({
            message: error?.response?.data?.result?.error,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    onMounted(getData);

    const editarQuantidade = async (row) => {
      console.log(row);
    };

    const receberTransportador = (value) => {
      finalizacaoPessoas.value.transportador = value.id;
    };

    const receberSolicitante = (value) => {
      finalizacaoPessoas.value.solicitante = value.id;
    };

    const receberSeparador = (value) => {
      finalizacaoPessoas.value.separador = value.id;
    };

    const imprimirPicking = async () => {
      router.push({ name: "pkg-imprimir", params: { id: numero.value } });
    };

    const imprimirPickingAgrupado = async () => {
      router.push({
        name: "pkg-imprimir-agrupado",
        params: { id: numero.value },
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        filtros.value.unidade = store.state.org.unidadeData;
      }
    );
    const handleRequest = async () => {
      //( pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watchDebounced(
      [
        () => filtros.value.unidade,
        () => filtros.value.requisicao,
        () => filtros.value.reserva,
        () => filtros.value.deposito,
        () => filtros.value.centro,
        () => filtros.value.lote,
      ],
      () => {
        handleRequest();
      },
      { debounce: 400 }
    );

    return {
      filtros,
      getData,
      pagination,
      disable,
      numero,
      columns,
      handleRequest,
      editarQuantidade,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      confirmacao,
      enviar,
      idPicking,
      status,
      mobile,
      rows,
      receberTransportador,
      receberSolicitante,
      receberSeparador,
      finalizacaoPessoas,
      form,
      labelSolicitante,
      dataCriacao,
      descricao,
      observacao,
      loteBase,
      comentario,
      dataEnvio,
      dataRecebimento,
      dataCancelamento,
      unidadeNomeDestino,
      unidadeNomeOrigem,
      imprimirPicking,
      imprimirPickingAgrupado,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.texto-titulo {
  font-size: 20px;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.titulo-tabela {
  font-size: 18px;
}
.icon-modal {
  font-size: 22px;
}
.texto-titulo-modal {
  font-size: 16px;
  font-weight: bold;
}
.card {
  border: 1px solid #707070;
}
.modal {
  max-width: 426px;
  min-width: 426px;
}
@media (max-width: 1024px) {
  .texto-titulo-input {
    font-size: 15px;
  }
  .texto-titulo-radio {
    font-size: 18px;
  }
  .titulo-tabela {
    font-size: 20px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .btn-grid {
    font-size: 16px;
  }
  .modal {
    max-width: 626px;
    min-width: 626px;
  }
}
@media (max-width: 600px) {
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .texto-colunas {
    font-size: 10px;
  }
  .input-grid {
    width: 70px;
    outline: none;
  }
  .texto-titulo {
    font-size: 17px;
  }
  .texto-titulo-input {
    font-size: 15px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .btn-grid {
    font-size: 14px;
  }
}
</style>

<style>
.quantidade-input-picking .q-field__control:before {
  border-color: red !important;
}
</style>
